import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {SVGICONS} from '@ey/icons';
import {navigationIcCheck24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {currentResource} from '../../../util/utils';
import {taskStatus, TaskStatusIds} from '../../../util/uiconstants';
import Icon from '../BaseComponentWrappers/MotifIcon';

function TaskStatusIcon({taskStatusId, isEPEQRSignOffComplete}) {
	const _taskStatus =
		taskStatusId === TaskStatusIds.Complete && isEPEQRSignOffComplete
			? taskStatus[TaskStatusIds.Complete]
			: taskStatus[taskStatusId];

	const taskStatusLabel = currentResource.TaskStatus.find((item) => item.id === taskStatusId)?.status;

	return (
		<StyledTaskStatusIcon className="StyledTaskStatusIcon" taskStatusId={taskStatusId}>
			<span className={`task-status-${_taskStatus.className}`}>
				<SVGICONS styleName="medium" name={_taskStatus.className} hoverText={taskStatusLabel} />
				<Icon className="hide" src={navigationIcCheck24px} />
			</span>
		</StyledTaskStatusIcon>
	);
}

TaskStatusIcon.propTypes = {
	taskStatusId: PropTypes.number,
	isEPEQRSignOffComplete: PropTypes.bool.isRequired
};

export default TaskStatusIcon;

const StyledTaskStatusIcon = styled.section`
	width: var(--px-30);
	span {
		width: var(--px-24);
		height: var(--px-24);
		svg.medium {
			cursor: default;
			stroke-width: var(--px-3);
			path {
				&:last-child {
					stroke: var(--green-500);
				}
			}
		}
		&.task-status-open {
			path {
				&:last-child {
					stroke: var(--neutrals-300);
				}
			}
		}
		&.task-status-removed {
			width: var(--px-30);
			margin-left: var(--px-2);
			svg.medium {
				path {
					stroke: transparent;
				}
			}
		}
		&.task-status-complete {
			svg.medium {
				path {
					stroke: var(--green-500);
				}
			}
		}
	}
`;
